import React from "react";
import "../css/labelAndInputField.css";
import "../css/label.css";
import "../css/inputField.css";
import "../css/customErrorForFields.css";
import Label from "./Label";
import InputField from "./InputField";
import "../../trial/theme.css"

export default function LabelAndInputField({
  style,
  controlId,
  controlName,
  labelText,
  isCompulsary,
  placeholder,
  inputType,
  value,
  handleInputChange,
  errorMessage,
  isReadOnly,
  minDate,
  isRequired,
  maxLength,
  pattern,
  customClassName,
  suffixIcon,
  wrapperClass,
  handleBlur,
  ...props
}) {

  return (
    
      <div  style={style}  className={`custom-field-wrapper ${wrapperClass || ""}`}>
        {/* Label */}
        {labelText && (
          <Label
            className={"custom-label"}
            labelText={labelText}
            isCompulsary={isCompulsary}
          />
        )}
        {/* Input */}
        <InputField
          controlId={controlId}
          controlName={controlName}
          inputType={inputType}
          value={value}
          handleInputChange={handleInputChange}
          errorMessage={errorMessage}
          isReadOnly={isReadOnly}
          minDate={minDate}
          isRequired={isRequired}
          maxLength={maxLength}
          pattern={pattern}
          handleBlur={handleBlur}
          placeholder={placeholder}
          customClassName={customClassName}
          {...props}
          suffixIcon={suffixIcon}
        />
      </div>

  );
}